import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=0610c7c2"
import script from "./CurrencyInput.ts?vue&type=script&lang=ts&external"
export * from "./CurrencyInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports